import type { ElementType } from "react";
import DOMPurify from "dompurify";
import isString from "lodash/isString";

export interface SanitizeHTMLStringProps {
  as?: ElementType;
  className?: string;
  content?: string;
  dataTestId?: string;
  sanitizeProps?: Record<string, any>;
}

export const SanitizeHTMLString = ({
  content,
  sanitizeProps,
  as = "span",
  className,
  dataTestId,
}: SanitizeHTMLStringProps) => {
  if (!content || !isString(content)) {
    return null;
  }

  const clean = DOMPurify.sanitize(content, {
    ...sanitizeProps,
  });

  const Component = as;

  return (
    <Component
      className={className}
      dangerouslySetInnerHTML={{ __html: clean }}
      data-testid={dataTestId}
    />
  );
};
